import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCogs } from 'react-icons/fa';
import { MdGroupWork } from 'react-icons/md';
import { PropagateLoader } from 'react-spinners';

import BreadCrumb from '~/components/BreadCrumb';
import DataLoadButton from '~/components/Buttons/DataLoad';
import DefaultInput from '~/components/Inputs/Default';
import EditButton from '~/components/Buttons/Edit';
import Pagination from '~/components/Pagination';
import NewButton from '~/components/Buttons/New';

import { getPermByName } from '~/utils';

import { useAuth } from '~/hooks/auth';

import api from '~/services/api';

import { Container, Table, Td } from './styles';

interface IPolicyGroup {
  id: string;
  name: string;
}

const AMOUNT_PER_PAGE = 5;

const List: React.FC = () => {
  const { user } = useAuth();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState('');
  const [policyGroups, setPolicyGroups] = useState<IPolicyGroup[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPolicyGroups = async () => {
      await api
        .get(
          `/policygroups?page=${page}&filter=${filter}&amount=${AMOUNT_PER_PAGE}`,
        )
        .then(response => {
          setPolicyGroups(response.data[0]);
          setCount(response.data[1]);
          setLoading(false);
        });
    };

    loadPolicyGroups();
  }, [page, filter]);

  return (
    <Container>
      <BreadCrumb
        main="Configurações"
        path="/configurations/main"
        firstChild="Grupos Políticas Comerciais"
        mainIcon={FaCogs}
        firstChildIcon={MdGroupWork}
        mainColored
      />

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          columnGap: '1rem',
          rowGap: '1rem',
          justifyContent: 'space-between',
          alignItems: 'end',
        }}
      >
        <div style={{ width: '100%', maxWidth: 680 }}>
          <DefaultInput
            name="search"
            labelText="Pesquisar"
            type="text"
            onChange={event => {
              setFilter(event.target.value);
              setPage(0);
            }}
          />
        </div>

        {getPermByName('conf_policy_groups_data_load', user) && (
          <Link to="/configurations/policygroups/dataload">
            <DataLoadButton />
          </Link>
        )}
      </div>

      <Table>
        <thead>
          <tr>
            <th style={{ width: '90%' }}>Nome</th>
            <th style={{ width: '10%' }} />
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <Td colSpan={2} style={{ padding: '3rem', textAlign: 'center' }}>
                <PropagateLoader color="#276c8d" />
              </Td>
            </tr>
          ) : policyGroups.length > 0 ? (
            policyGroups.map(group => (
              <tr key={group.id}>
                <Td heading="NOME" style={{ width: '90%' }}>
                  {group.name}
                </Td>
                <Td heading="" style={{ width: '10%' }}>
                  <Link
                    to={{
                      pathname: `/configurations/policygroups/record`,
                      state: group,
                    }}
                  >
                    <EditButton />
                  </Link>
                </Td>
              </tr>
            ))
          ) : (
            <tr>
              <Td colSpan={2} style={{ textAlign: 'center' }}>
                Nenhuma informação disponível
              </Td>
            </tr>
          )}
        </tbody>
      </Table>

      <div style={{ display: 'flex', marginTop: '2rem' }}>
        <Pagination
          page={page}
          count={count}
          amountPerPage={AMOUNT_PER_PAGE}
          setPage={setPage}
        />

        <Link to="/configurations/policygroups/record">
          <NewButton />
        </Link>
      </div>
    </Container>
  );
};

export default List;
